import React from 'react'
// @ts-ignore
import { Gauge } from '@netbasequid/chart'
import { useDisplayTheme } from 'hooks/useUiState'
import { GaugeChartProps } from './types'

const GaugeChart = ({
  data,
  chartTitle,
  legendPosition,
  showLegend = false,
  showAccessibilityButton,
  lowerBoundPercent,
  startAngle = '-135',
  endAngle = '135',
  showAxisLabel = true,
  colorSettings,
  yAxisMin = 0,
  yAxisMax = 100,
  yAxisLabelFormatter,
  size,
  centerSection
}: GaugeChartProps) => {
  const theme = useDisplayTheme()

  return (
    <Gauge
      mode={theme}
      data={data}
      chartTitle={chartTitle}
      legendPosition={legendPosition}
      showLegend={showLegend}
      showAccessibilityButton={showAccessibilityButton}
      lowerBoundPercent={lowerBoundPercent}
      startAngle={startAngle}
      endAngle={endAngle}
      showAxisLabel={showAxisLabel}
      colorSettings={colorSettings}
      yAxisMin={yAxisMin}
      yAxisMax={yAxisMax}
      yAxisLabelFormatter={yAxisLabelFormatter}
      size={size}
      centerSection={centerSection}
    />
  )
}

export default GaugeChart

export * from './types'
